export const RAFFLE = "Raffle"
export const DRAW_MACHINE = "Draw Machine"


export const RAFFLE_PAGES = {
    DISPLAY: "display",
    TABLE: "table",
}
// tooltip names
export const BACK = "Back"

export const STEP_DRAW_MACHINE_INDEX = 0
export const STEP_SET_WINNER_PRICE_INDEX = 1
export const STEP_IDENTIFY_WINNER_INDEX = 2

export const RAFFLE_CUSTOMER_FIELDS = [
    {id: 'files', label: 'Picture', align: "center"},
    {id: 'firstName', label: 'First Name', align: "center"},
    {id: 'lastName', label: 'Last Name', align: "center"},

]

export const RAFFLE_FIELDS = [
    {},
    {id: 'files', label: 'Picture', align: "center"},
    {id: 'name', label: 'Name', align: "center"},
    {id: 'winnerNumber', label: 'Winner Number', align: "center"},
    {id: 'amount', label: 'Amount', align: "center"},
]

export const STEPPER_HEADINGS = ["Draw Machine", "Set Winner Amount", "Validate Customer"]

export const DEFAULT_PDF_ZOOM = 1.5

